import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy URL → current canonical page
export const Route = createFileRoute("/it-services-support")({
  beforeLoad: () => {
    throw redirect({ to: "/services/managed-it-services", statusCode: 301 });
  },
});
